import type { ReactNode } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { useFulfillmentV2Launch } from '@/infrastructure/FulfillmentV2Launch';
import { PrintSetupBanner } from '@/pages/fulfillment/components/PrintSetupBanner';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const launch = useFulfillmentV2Launch();
  // Fulfillment 2.0 is still being built; warn before an operator runs live work through it.
  // Once the launch switch is on, 2.0 is the live system and the warning would send them back to V1.
  const onFulfillment = useLocation().pathname.startsWith('/fulfillment');
  const showsFulfillmentWarning = onFulfillment && launch !== 'on';

  return (
    <>
      <Navbar />
      <Container fluid className="px-3">
        {showsFulfillmentWarning && (
          <Alert variant="warning" className="mt-3 mb-3">
            <strong>Work in progress.</strong> Fulfillment 2.0 is not released yet — do not use these screens for real
            production work. Keep handling live orders in OMS Center.
          </Alert>
        )}
        {/* Every Fulfillment screen reminds the desk how a packing PC prints straight to the label printer (SSD-7389). */}
        {onFulfillment && <PrintSetupBanner />}
        {children}
      </Container>
    </>
  );
};

export default Layout;
